import React, {Component} from 'react';
import {Button, Input, Label} from "reactstrap";
import Alert from "react-s-alert";
import * as base64_arraybuffer from "base64-arraybuffer";

class ImageField extends Component {

	constructor(props) {
		super(props)

		this.state = {
			key: Math.random().toString(36)
		};
		this.onChangeField = this.onChangeField.bind(this);
		this.onChangeFile = this.onChangeFile.bind(this);
		this.onReset = this.onReset.bind(this);
	}

	onChangeFile(e) {
		if (!e) return;
		let {image} = this.props;
		let files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
		let theFile = files[0]
		if (theFile.size <= 102400) {//100KB
			Alert.closeAll();

			let fileReader = new FileReader();
			let content;
			fileReader.readAsArrayBuffer(theFile)
			fileReader.onload = () => {
				content = fileReader.result;
				image.file = base64_arraybuffer.encode(content);//content;
				image.fileName = theFile.name;
				image.mimeType = theFile.type;
				this.props.setImage(image);
			}

		} else {
			this.setState({key: Math.random().toString(36)})
			Alert.error("Dosya boyutu maksimum 100KB olmalıdır.", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});

		}
	}

	onReset(e) {
		if (!e) return

		let image = {
			file: null,
			width: 100,
			height: 100
		}
		this.setState({key: Math.random().toString(36)})
		this.props.setImage(image)
	}

	onChangeField(e) {
		if (!e) return;
		let target = e.target;

		let {image} = this.props;
		let numValue = Number(target.value);


		if (numValue > 255) {
			numValue = 255;
		}

		if (Number.isInteger(numValue) && numValue >= 0) {
			image[target.name] = numValue;
		}

		this.props.setImage(image);
	}

	render() {
		let {image, logoTitle} = this.props;

		return (
			<div style={{display: 'block', padding: '20px 5px 20px 10px', border: 'solid 1px #cacaca', borderRadius: '5px', width: '100%', margin: '5px 0'}}>
				<div style={{width: '100%'}}>
					<h4 className="card-title">
						{logoTitle}
					</h4>
				</div>

				{image &&
					<div style={{display: 'block', width: '100%'}}>
						<div style={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							padding: '10px 15px',
							margin: '10px 0',
							background: '#d4d4d4',
							borderRadius: '5px'
						}}>
							<div style={{maxWidth: '145px'}}>
								<Input key={this.state.key || ''} type="file" name="file" accept=".png,.jpg,.jpeg"
									   multiple={false}
									   name='myfile'
									   style={{opacity: 1}} onChange={(e) => this.onChangeFile(e)}/>
							</div>

							<div>
								<Button onClick={this.onReset} style={{background: 'rgb(255, 204, 204)'}} className="TekBtn delete">
									Temİzle
								</Button>
							</div>
						</div>

						<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%'}}>
							<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: '50%', padding: '0 10px 0 5px'}}>
								<div style={{width: '60%'}}>
									<Label style={{margin: 0, fontWeight: 'bold'}}>Yükseklik (1-255)</Label>
								</div>

								<div style={{width: '40%'}}>
									<Input type="number" value={image.height}
										   min={0} max={255} onChange={this.onChangeField} name="height"/>
								</div>
							</div>

							<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: '50%', padding: '0 10px 0 5px'}}>
								<div style={{width: '60%'}}>
									<Label style={{margin: 0, fontWeight: 'bold'}}>Genişlik (1-255)</Label>
								</div>

								<div style={{width: '40%'}}>
									<Input type="number" value={image.width}
										   min={0} max={255} onChange={this.onChangeField} name="width"/>
								</div>
							</div>
						</div>

					</div>
				}
			</div>
		)
	}
}

export default ImageField;
